import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  Toolbar,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";


const Sidebar = ({ mobileOpen, handleDrawerToggle }) => {
  const drawerWidth = 240;
  const location = useLocation();

  const pages = [
    { name: "Home", path: "/" },
    { name: "Holdings", path: "/holdings" },
    { name: "Smart Alerts", path: "/alerts" },
    { name: "Orders", path: "/orders" },
    { name: "About", path: "/about" },
    { name: "Alerts", path: "/info/alerts" },
  ];

  const drawer = (
    <Box sx={{ width: drawerWidth }}>
      <Toolbar /> {/* Keeps content aligned with AppBar */}
      <List>
        {pages.map((page) => (
          <ListItem
            key={page.name}
            disablePadding
            selected={location.pathname === page.path} // Highlight active page
          >
            <ListItemButton
              component={Link}
              to={page.path}
              sx={{
                "&.Mui-selected": { backgroundColor: "#e0f7fa" }, // Custom active style
              }}
            >
              <ListItemText primary={page.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      {/* Temporary Drawer for Mobile */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }} // Improves performance for mobile
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": { width: drawerWidth },
        }}
      >
        {drawer}
      </Drawer>

      {/* Persistent Drawer for Desktop */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": { width: drawerWidth },
        }}
        open
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default Sidebar;
